import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(static)/terms-and-conditions/TermsAndConditions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
